import { useEffect, useState } from 'react';

import { getTraceabilityGraph } from '../api/traceabilityApi';

export function useTraceabilityGraph(commodity, chainId) {
  const [request, setRequest] = useState(null);
  const requestKey = chainId ? `${commodity}:${chainId}` : null;

  useEffect(() => {
    let live = true;
    if (!chainId) return () => { live = false; };
    getTraceabilityGraph(commodity, chainId)
      .then((graph) => live && setRequest({
        key: requestKey,
        graph,
        error: null,
      }))
      .catch((error) => live && setRequest({
        key: requestKey,
        graph: null,
        error,
      }));
    return () => {
      live = false;
    };
  }, [commodity, chainId, requestKey]);

  const current = request?.key === requestKey ? request : null;
  return {
    graph: current?.graph ?? null,
    loading: Boolean(requestKey && !current),
    error: current?.error ?? null,
  };
}
